var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g3, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunriseLogoTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "603.547px",
    height: "340.022px",
    viewBox: "201.307 151.922 603.547 340.022",
    enableBackground: "new 201.307 151.922 603.547 340.022",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M521.661,212.781l1.839-21.057l1.989,0.172l-1.838,21.057L521.661,212.781z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M522.339,227.359l-2-0.182l-1.964,22.635h1.964L522.339,227.359z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M542.344,209.672l3.698-21.328l1.958,0.338l-3.698,21.328L542.344,209.672z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M543.344,223.115l-1.964-0.344l-5.15,29.292l1.969,0.313L543.344,223.115z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M571.797,188.912l6.183-23.104l1.932,0.516l-6.182,23.104L571.797,188.912z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M565.401,212.672l2.125-7.932l1.932,0.516l-2.125,7.932L565.401,212.672z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M564.136,225.083l-1.938-0.531l-8.365,31.224l1.906,0.531L564.136,225.083z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M600.88,179.073l8.709-23.948l1.875,0.688l-8.709,23.943L600.88,179.073z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M596.786,196.135l-1.875-0.682l-23.906,65.755l1.87,0.656L596.786,196.135z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M616.308,206.495l10.052-21.563l1.813,0.849l-10.058,21.563L616.308,206.495z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M611.271,222.083l-1.813-0.844l-21.849,46.838l1.813,0.844L611.271,222.083z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M646.917,201.24l12.713-22.005l1.729,1l-12.714,22.005L646.917,201.24z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M614.266,257.844l23.969-41.5l1.729,1l-23.969,41.5L614.266,257.844z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M610.521,268.328l-1.713-0.875l-4.995,8.776l1.714,1L610.521,268.328z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M646.089,246.912l12.63-18.026l1.636,1.151l-12.631,18.021L646.089,246.912z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M639.114,260.427l-1.656-1.125l-18.572,26.542l1.625,1.125L639.114,260.427z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M687.802,231.734l16.234-19.349l1.531,1.287l-16.234,19.344L687.802,231.734z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M678.198,246.224l-1.531-1.281l-43.453,51.802l1.531,1.276L678.198,246.224z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M693.817,261.542l16.756-16.76l1.411,1.417l-16.75,16.755L693.817,261.542z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M647.948,310.26l35.807-35.844l-1.406-1.406l-35.807,35.849L647.948,310.26z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M718.724,271.667l18.912-15.88l1.286,1.531l-18.911,15.88L718.724,271.667z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M707.073,284.099l-1.281-1.531l-47.042,39.5l1.25,1.588L707.073,284.099z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M739.203,287.703l20.677-14.495l1.146,1.635l-20.678,14.495L739.203,287.703z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M726.172,299.208l-1.12-1.625l-55.25,38.563l1.12,1.625L726.172,299.208z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M725.333,325l19.469-11.24l1,1.729l-19.469,11.239L725.333,325z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M690.578,345.016l21.411-12.365l1,1.734l-21.411,12.365L690.578,345.016z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M729.229,350.448l19.739-9l0.828,1.823l-19.739,8.995L729.229,350.448z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M715.125,356.849l-0.844-1.813l-26.188,12.333l0.839,1.781L715.125,356.849z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M779.969,352.958l24.203-8.802l0.683,1.875l-24.203,8.807L779.969,352.958z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M696.906,383.188l66.526-24.219l0.682,1.875l-66.525,24.225L696.906,383.188z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M740.771,390.244l20.808-5.572l0.516,1.928l-20.802,5.578L740.771,390.244z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M727.047,396.005l-0.5-1.937l-25.969,6.994c0.156,0.656,0.344,1.281,0.5,1.938L727.047,396.005z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M769.688,407.156l23.302-4.114l0.35,1.969l-23.303,4.114L769.688,407.156z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M754.114,411.864l-0.344-1.932l-49.385,8.708c0,0.625,0.219,1.281,0.344,1.938L754.114,411.864z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 774.667,
    y: 428,
    width: 25.333,
    height: 0.922
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M774.849,430.531l23.729-2.078l0.172,1.989l-23.724,2.078L774.849,430.531z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 204,
    y: 428,
    width: 28,
    height: 0.922
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M204.865,430.495l0.172-1.99l26.245,2.297l-0.172,1.99L204.865,430.495z"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M267.969,415.255l0.344-1.963l25.734,4.541l-0.349,1.969L267.969,415.255z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M230.104,408.63l0.349-1.969l23.979,4.229l-0.349,1.969L230.104,408.63z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M243.162,387.275l0.516-1.932l55.417,14.854l-0.516,1.932L243.162,387.275z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M201.307,376.052l0.516-1.933l26.537,7.115l-0.521,1.927L201.307,376.052z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M285.943,375.958l-0.683,1.844l21.849,7.989l0.656-1.869L285.943,375.958z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M250.208,365.078l0.688-1.88l22.203,8.083l-0.683,1.88L250.208,365.078z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M294.781,358.005l-0.844,1.813l19.974,9.364l0.844-1.781L294.781,358.005z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M260.391,344.146l0.844-1.813l21.302,9.938l-0.844,1.807L260.391,344.146z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M259.677,317.005l1-1.729l51.823,29.927l-1,1.729L259.677,317.005z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M220.552,294.406l1-1.734l24.813,14.333l-0.995,1.729L220.552,294.406z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M299.708,312.979l-1.151,1.625l33.276,23.292c0.375-0.531,0.745-1.094,1.151-1.625L299.708,312.979z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M265.734,291.599l1.146-1.636l20.813,14.578l-1.146,1.636L265.734,291.599z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M289.344,278.787l1.287-1.531l45.406,38.114l-1.281,1.526L289.344,278.787z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M255.021,249.958l1.286-1.531l21.734,18.245l-1.281,1.526L255.021,249.958z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M356.239,308.859l-10.078-10.182l-1.406,1.406l10.084,10.083L356.239,308.859z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M318.286,273.713l1.412-1.417l19.578,19.583l-1.412,1.417L318.286,273.713z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M288.719,244.104l1.412-1.417l18.76,18.771l-1.411,1.411L288.719,244.104z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M354.089,278.349l-1.531,1.281l15.453,18.391l1.5-1.276L354.089,278.349z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M328.578,250.99l1.531-1.287l15.229,18.156l-1.531,1.287L328.578,250.99z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M361.453,253.807l-1.62,1.125l22.35,32.037l1.625-1.125L361.453,253.807z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M336.839,223.016l1.635-1.146l14.484,20.693l-1.635,1.146L336.839,223.016z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M372.317,229.984l-1.719,1l26.787,46.401l1.713-1L372.317,229.984z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M349.516,194.313l1.729-1l13.359,23.146l-1.729,1L349.516,194.313z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M402.005,239.917l-1.813,0.839l13.109,28.104l1.781-0.844L402.005,239.917z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M383.917,205.854l1.813-0.844l10.313,22.13l-1.808,0.844L383.917,205.854z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M415.484,222.323l1.88-0.682l10.428,28.662l-1.875,0.688L415.484,222.323z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M405.542,194.922l1.88-0.682l6.156,16.932l-1.875,0.682L405.542,194.922z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 389.333,
    y: 151.922,
    width: 13.334,
    height: 28.078
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M390.125,152.599l1.875-0.683l9.761,26.818l-1.875,0.682L390.125,152.599z"
  })))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M442.458,231.609l-1.938,0.531l6.495,24.229l1.938-0.531L442.458,231.609z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M430.844,195.859l1.933-0.516l6.156,22.979L437,218.844L430.844,195.859z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M462.469,228.922l-1.969,0.344l4.089,23.109l1.938-0.313L462.469,228.922z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M452.536,193.354l1.959-0.338l4.016,23.162l-1.959,0.338L452.536,193.354z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M479.636,195.297h-1.995l4.771,54.672h2L479.636,195.297z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M473.938,153.25l1.989-0.177l2.344,26.755L476.276,180L473.938,153.25z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M502.391,249.125v-43.432h-1.995v43.432H502.391z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M500.396,165.162h1.995v25.698h-1.995V165.162z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 300,
    y: 254.667,
    width: 402.667,
    height: 174.255
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D79A2B",
    d: "M600.688,629.344l1.688-1c4.453-2.625,8.813-5.401,13.078-8.339l1.594-1.119 c4.214-3.125,8.333-6.245,12.297-9.37l1.5-1.25c3.933-3.339,7.771-6.839,11.422-10.489l1.375-1.375 c7.761-7.823,14.828-16.234,21.198-25.229l1.119-1.594c6.287-9.063,11.792-18.573,16.516-28.536 c0.25-0.594,0.531-1.156,0.813-1.75c2.151-4.683,4.151-9.365,5.959-14.365l0.656-1.807c1.729-4.875,3.281-9.818,4.65-14.834 c0-0.625,0.344-1.219,0.5-1.844c1.313-4.994,2.438-10.052,3.37-15.172c0-0.656,0.188-1.281,0.313-1.906 c0.875-5.088,1.531-10.208,2-15.427l0.188-1.901c0.438-5.453,0.656-10.947,0.656-16.489c0-5.536-0.219-11.031-0.656-16.484 l-0.188-1.938c-0.469-5.183-1.125-10.333-2-15.391c0-0.656-0.219-1.281-0.313-1.906c-0.933-5.141-2.058-10.198-3.37-15.177 c-0.156-0.62-0.344-1.245-0.5-1.87c-2.911-10.646-6.666-20.979-11.266-31.005c-0.281-0.563-0.563-1.156-0.813-1.75 c-2.25-4.682-4.619-9.37-7.182-13.771c-0.344-0.563-0.656-1.125-0.995-1.656c-2.594-4.495-5.401-8.865-8.339-13.115l-1.119-1.588 c-3.125-4.219-6.245-8.339-9.365-12.302l-1.25-1.469c-3.328-3.953-6.828-7.776-10.489-11.458l-1.375-1.375 c-3.651-3.625-7.489-7.151-11.422-10.489l-1.5-1.25c-3.964-3.313-8.083-6.464-12.297-9.37l-1.594-1.094 c-4.161-2.953-8.521-5.745-13.078-8.364l-1.688-0.969c-4.464-2.594-9.083-4.964-13.766-7.183l-1.933-0.875 c-4.682-2.182-9.364-4.182-14.359-5.963l-1.813-0.656c-4.869-1.75-9.813-3.307-14.828-4.682l-1.838-0.5 c-4.995-1.313-10.053-2.438-15.172-3.339l-1.938-0.469c-5.089-0.844-10.209-1.531-15.417-2h-1.906 c-5.12-0.438-10.302-0.656-15.609-0.688h-1.933c-5.213,0-10.396,0.25-15.609,0.688h-1.938c-5.177,0.469-10.328,1.156-15.385,2 l-1.906,0.344c-5.151,0.901-10.209,2.026-15.172,3.339l-1.87,0.5c-10.558,2.958-20.797,6.766-30.719,11.427l-1.745,0.813 c-4.713,2.219-9.364,4.589-13.797,7.183l-1.656,0.969c-4.494,2.62-8.864,5.411-13.109,8.364l-1.563,1.094 c-4.244,3.125-8.333,6.245-12.484,9.37l-1.469,1.25c-3.963,3.338-7.771,6.864-11.453,10.489l-1.375,1.375 c-7.75,7.833-14.817,16.24-21.197,25.229l-1.089,1.588c-6.302,9.057-11.808,18.568-16.516,28.542l-0.813,1.75 c-2.183,4.714-4.151,9.365-5.958,14.359l-0.656,1.813c-5.714,15.933-9.333,32.323-10.865,49.178c0,0.656,0,1.281-0.156,1.938 c-0.438,5.433-0.688,10.927-0.688,16.484c0,5.563,0.25,11.026,0.688,16.489c0,0.625,0,1.281,0.156,1.906 c0.469,5.214,1.156,10.334,2.031,15.422c0,0.625,0.188,1.25,0.313,1.906c0.901,5.12,2.026,10.178,3.338,15.172 c0.156,0.625,0.344,1.219,0.5,1.844c2.964,10.609,6.781,20.906,11.453,30.881c0.25,0.594,0.531,1.156,0.813,1.75 c2.208,4.682,4.599,9.271,7.183,13.771l0.963,1.683c8.542,14.594,18.761,27.896,30.656,39.906c0.469,0.469,0.906,0.938,1.37,1.375 c7.839,7.766,16.255,14.828,25.255,21.203l1.563,1.119c9.068,6.287,18.589,11.792,28.563,16.521l1.745,0.813 c10.016,4.604,20.339,8.359,30.969,11.271l1.87,0.5c4.974,1.313,10.031,2.433,15.172,3.37l1.906,0.313 c5.057,0.844,10.203,1.531,15.385,2l1.938,0.188c5.12,0.406,10.303,0.625,15.609,0.656h1.933c5.214,0,10.396-0.25,15.609-0.656 l1.901-0.188c5.213-0.469,10.333-1.156,15.422-2l1.906-0.313c5.119-0.938,10.177-2.058,15.172-3.37l1.838-0.5 c10.641-2.911,20.975-6.667,31-11.271l1.745-0.813C591.542,634.276,596.161,631.906,600.688,629.344z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(264.394831, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M114.465,96.299c5.084,2.25,7.625,6.031,7.625,11.333c0,4.656-1.458,8.433-4.375,11.333 c-3.057,3.058-7.239,4.584-12.541,4.584c-2.209,0-4.511-0.209-6.896-0.625c-1.875-0.334-3.76-0.781-5.646-1.354l-2.042-0.688 v-12.688h3.459c0.791,0,1.26,0.396,1.416,1.188c0.084,0.391,0.198,1.542,0.354,3.458l0.208,3.104 c3.651,1.323,6.511,1.979,8.584,1.979c2.067,0,3.802-0.234,5.208-0.709c1.359-0.427,2.442-1.067,3.25-1.916 c1.776-1.636,2.667-3.865,2.667-6.688c0-2.719-1.266-4.781-3.792-6.188c-1.125-0.709-2.396-1.271-3.813-1.688 c-5.031-1.553-7.989-2.542-8.875-2.959c-1.364-0.609-2.656-1.458-3.875-2.541c-2.489-2.209-3.729-5.354-3.729-9.438 c0-3.709,1.339-6.901,4.021-9.584c2.9-2.817,6.656-4.229,11.271-4.229c4.875,0,9.589,0.938,14.146,2.813v11.625h-3.375 c-0.849,0-1.344-0.396-1.479-1.188c0-0.136-0.037-0.615-0.104-1.438c-0.073-0.834-0.203-2.443-0.396-4.834 c-3.281-0.885-6.053-1.333-8.313-1.333c-3.042,0-5.391,0.75-7.042,2.25c-1.599,1.458-2.396,3.333-2.396,5.625 c0,2.5,1.271,4.453,3.813,5.854c1.025,0.656,2.338,1.239,3.938,1.75c4.234,1.416,7.192,2.479,8.875,3.188H114.465z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.12616, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M148.604,75.59c0,0.75-0.375,1.198-1.125,1.334l-4.021,0.771v25.563c0,5.833-1.786,10.677-5.354,14.521 c-3.666,3.891-8.578,5.834-14.729,5.834c-6.1,0-10.979-1.943-14.646-5.834c-3.614-3.844-5.416-8.688-5.416-14.521V77.694 c-2.25-0.417-3.594-0.698-4.021-0.854c-0.708-0.135-1.063-0.583-1.063-1.333v-2.958h17.688v2.958c0,0.75-0.375,1.198-1.125,1.333 c-1.031,0.198-2.578,0.459-4.646,0.792v25.5c0,4.406,1.172,7.875,3.521,10.417c2.386,2.682,5.651,4.021,9.792,4.021 c4.125,0,7.386-1.339,9.792-4.021c2.344-2.625,3.521-6.073,3.521-10.354V77.632l-4.646-0.792 c-0.75-0.135-1.125-0.583-1.125-1.333v-2.958h17.604V75.59z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.694859, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M163.773,75.652c0,0.709-0.385,1.136-1.146,1.271l-4,0.833v45.292h-3.458 c-0.948,0-1.745-0.396-2.396-1.188l-29.229-38.042c0.094,0.808,0.146,1.891,0.146,3.25v30.854 c1.302,0.182,2.875,0.458,4.708,0.833c0.667,0.141,1,0.563,1,1.271v3.021h-16.771v-3.021c0-0.708,0.354-1.13,1.063-1.271l4-0.833 V77.757c-2.25-0.417-3.583-0.692-4-0.833c-0.708-0.136-1.063-0.584-1.063-1.334v-3.041h8.583c0.609,0,1.063,0.072,1.354,0.208 c0.177,0.099,0.526,0.406,1.042,0.917l29.166,38.041c-0.099-0.65-0.146-1.775-0.146-3.375V77.757 c-1.364-0.177-2.448-0.354-3.25-0.521c-0.792-0.167-1.261-0.271-1.396-0.313c-0.75-0.136-1.125-0.563-1.125-1.271v-3.104h16.916 V75.652z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.689926, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M168.063,118.611c0.334,0.099,0.589,0.26,0.771,0.479c0.192,0.209,0.291,0.475,0.291,0.792v3.104h-7.333 c-1.224,0-2.12-0.49-2.688-1.479l-13.083-18.042c-0.334-0.458-0.761-0.854-1.271-1.188c-0.432-0.275-1.141-0.416-2.125-0.416 h-4.5v15.916l3.938,0.834c0.334,0.099,0.604,0.26,0.813,0.479c0.209,0.209,0.313,0.475,0.313,0.792v3.042H126.23v-3.042 c0-0.317,0.089-0.583,0.271-0.792c0.193-0.219,0.448-0.38,0.771-0.479l4.083-0.834V77.632l-4.083-0.854 c-0.323-0.094-0.578-0.25-0.771-0.458c-0.182-0.208-0.271-0.479-0.271-0.813v-3.104h18.667c3.135,0,5.9,0.334,8.291,1 c2.359,0.656,4.292,1.594,5.792,2.813c1.542,1.266,2.667,2.745,3.375,4.438c0.708,1.698,1.063,3.646,1.063,5.854 c0,1.739-0.286,3.375-0.854,4.917c-0.557,1.516-1.375,2.927-2.458,4.229c-1.083,1.323-2.375,2.375-3.875,3.167 c-1.875,1.042-3.614,1.724-5.208,2.042c0.844,0.531,1.594,1.239,2.25,2.125l10.916,14.938c2.25,0.375,3.563,0.604,3.938,0.688 H168.063z M144.46,96.924c2.067,0,3.833-0.234,5.291-0.709c1.401-0.469,2.667-1.172,3.792-2.104 c1.042-0.886,1.817-1.922,2.333-3.104c0.511-1.167,0.771-2.526,0.771-4.083c0-2.959-0.99-5.214-2.959-6.771 c-1.916-1.5-4.849-2.25-8.791-2.25h-6.834v19.021H144.46z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(407.032322, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M149.907,117.84l4.291,0.854c0.568,0.141,0.854,0.563,0.854,1.271v3.021h-16.979v-3.021 c0-0.75,0.323-1.197,0.979-1.354l4.083-0.771V77.632l-4.208-0.854c-0.573-0.135-0.854-0.563-0.854-1.271v-2.958h16.979v2.958 c0,0.75-0.354,1.198-1.063,1.333l-4.083,0.792V117.84z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.145069, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M167.381,96.299c5.084,2.25,7.625,6.031,7.625,11.333c0,4.656-1.458,8.433-4.375,11.333 c-3.057,3.058-7.239,4.584-12.541,4.584c-2.209,0-4.511-0.209-6.896-0.625c-1.875-0.334-3.76-0.781-5.646-1.354l-2.042-0.688 v-12.688h3.459c0.791,0,1.26,0.396,1.416,1.188c0.084,0.391,0.198,1.542,0.354,3.458l0.208,3.104 c3.651,1.323,6.511,1.979,8.584,1.979c2.067,0,3.802-0.234,5.208-0.709c1.359-0.427,2.442-1.067,3.25-1.916 c1.776-1.636,2.667-3.865,2.667-6.688c0-2.719-1.266-4.781-3.792-6.188c-1.125-0.709-2.396-1.271-3.813-1.688 c-5.031-1.553-7.989-2.542-8.875-2.959c-1.364-0.609-2.656-1.458-3.875-2.541c-2.489-2.209-3.729-5.354-3.729-9.438 c0-3.709,1.339-6.901,4.021-9.584c2.9-2.817,6.656-4.229,11.271-4.229c4.875,0,9.589,0.938,14.146,2.813v11.625h-3.375 c-0.849,0-1.344-0.396-1.479-1.188c0-0.136-0.037-0.615-0.104-1.438c-0.073-0.834-0.203-2.443-0.396-4.834 c-3.281-0.885-6.053-1.333-8.313-1.333c-3.042,0-5.391,0.75-7.042,2.25c-1.599,1.458-2.396,3.333-2.396,5.625 c0,2.5,1.271,4.453,3.813,5.854c1.025,0.656,2.338,1.239,3.938,1.75c4.234,1.416,7.192,2.479,8.875,3.188H167.381z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.876398, 368.958037)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B84D25",
    d: "M188.563,84.736h-3.396c-0.834,0-1.328-0.396-1.479-1.188l-0.479-5.438h-18.875v16.771h18.584v5.354 h-18.584v17.25h18.875l0.417-5.063c0.136-0.75,0.651-1.125,1.542-1.125h3.396v11.688h-36.208v-2.959 c0-0.75,0.354-1.192,1.063-1.333l4-0.771V77.694c-2.25-0.417-3.584-0.698-4-0.854c-0.709-0.135-1.063-0.583-1.063-1.333v-2.958 h36.208V84.736z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(480.879866, 368.958037)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(492.238038, 368.958037)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunriseLogoTitle);
export default __webpack_public_path__ + "static/media/sunrise_logo_title.a20bb295ec4df89b87396df9be31ed6a.svg";
export { ForwardRef as ReactComponent };